import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: true,
  totalRemain: 0,
  lastPurchaseAmount: 0,
  lowBalanceThreshold: 0,
};

const slice = createSlice({
  name: 'esignCredits',
  initialState,
  reducers: {
    successFetchEsignCredits: (state, { payload }) => ({
      ...state, ...payload, loading: false,
    }),
    failureFetchEsignCredits: (state) => ({
      ...state, loading: false,
    }),
    reset: () => initialState,
  },
});

export const {
  successFetchEsignCredits, failureFetchEsignCredits, reset: resetEsignCredits,
} = slice.actions;

export default slice.reducer;
